import React from 'react'
import * as S from './style'

const WrapperTableItem = ({ children }) => {
  return (
    <>
      <S.WrapperTableItem>{children}</S.WrapperTableItem>
    </>
  )
}

export { WrapperTableItem }
